/*
PURPOSE: Quote-aware (RFC-4180) CSV field splitting shared by every reader of the
public contribution-report CSV.
USE CASES:
- Parsing `wearecoral-contribution-report.csv` rows in the /trust financial
  transparency view, the ecosystem genre aggregation, the ecosystem-vitals card,
  and the artist payout checker.
DOMAIN BOUNDARIES:
- Pure string parsing only. No fetch, no domain-specific column knowledge, no
  aggregation logic — callers own their own positional destructuring.
ASSUMPTIONS:
- The producer (backend `neutraliseCsvCell` / `toCsvRow`) quote-escapes any cell
  containing a comma, quote, or newline per RFC-4180, doubling embedded quotes
  (`""`). A naive `row.split(',')` would shift columns for such a row (e.g. an
  artist named "Tyler, The Creator") and silently misclassify that row's data.
*/

/** Quote-aware CSV field split (RFC-4180). Handles quoted fields with embedded
 * commas and doubled `""` quotes; unquotes the result. */
export const splitCsvLine = (line: string): string[] => {
  const fields: string[] = [];
  let field = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (inQuotes) {
      if (ch === '"') {
        if (line[i + 1] === '"') { field += '"'; i++; } else { inQuotes = false; }
      } else {
        field += ch;
      }
    } else if (ch === '"') {
      inQuotes = true;
    } else if (ch === ',') {
      fields.push(field);
      field = '';
    } else {
      field += ch;
    }
  }
  fields.push(field);
  return fields;
};
